const normalize = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

export function getPromotionSearchTerm(campaign) {
    return String(campaign.MainTitle || '').match(/\bmodel\s*[:：-]\s*([a-z0-9][a-z0-9-]*)/i)?.[1] || campaign.MainTitle || '';
}

export function getPromotionProductUrl(product, language) {
    const id = Number(product.ProductId ?? product.ProductID);
    if (!Number.isInteger(id) || id <= 0) return null;
    return `/${encodeURIComponent(language)}/product-detail/${id}/${encodeURIComponent(product.CategoryName || 'shop')}/${encodeURIComponent(product.ProductName || product.MainTitle || 'product')}`;
}

export function getPromotionUrl(campaign, language) {
    return getPromotionProductUrl(campaign, language) || `/${encodeURIComponent(language)}/campaign/${campaign.CampaignId}/${encodeURIComponent(campaign.MainTitle || 'promotion')}`;
}

export function matchPromotionProducts(campaign, products) {
    const valid = products.filter(item => Number(item.ProductId ?? item.ProductID) > 0);
    const exact = valid.filter(item => normalize(item.ProductName) === normalize(campaign.MainTitle));
    if (exact.length) return exact;
    const term = getPromotionSearchTerm(campaign);
    if (term === campaign.MainTitle) return [];
    const model = normalize(term);
    return valid.filter(item => normalize(item.SKU || item.Sku) === model ||
        (` ${normalize(item.ProductName)} `).includes(` ${model} `));
}
